import { twMerge } from 'utilities/src/twMerge';
import React, { memo } from 'react';

import Skeleton from 'ui/src/components/Skeleton';
import { PostCardListFragment } from 'gql/graphql-operations';
import BlogCard, { BlogCardProps } from '../BlogCard';

export type CardListProps = Omit<BlogCardProps, 'post'> & {
  posts: (PostCardListFragment | null)[];
  componentsAfterCards?: React.ReactNode;
  classes?: string;
  isLoading?: boolean;
  isFullImage?: boolean;
};

const MemoizedBlogCard = memo(BlogCard);

export default function PostCardsList({
  posts,
  componentsAfterCards,
  withCategories,
  withSummary,
  classes,
  isLoading,
  withAuthorAvatar,
  CustomHeadingTag,
  isFullImage = false,
}: CardListProps) {
  return (
    <section
      className={twMerge(
        'mdS:grid-cols-2 mdS:gap-y-4 mdL:grid-cols-3 mb-16 grid grid-cols-1 gap-x-4 gap-y-6 last:mb-0',
        classes,
      )}
      role="list"
    >
      {posts.map((post, i) => {
        const isFirst = i === 0;
        return (
          post && (
            <div role="listitem" key={post?.id}>
              <Skeleton isLoading={isLoading} classes="h-[36rem] w-full">
                <MemoizedBlogCard
                  post={post}
                  withCategories={withCategories}
                  withSummary={withSummary}
                  withAuthor={!post?.postOptions?.elementsVisibilityOptions?.hideAuthor}
                  withAuthorAvatar={withAuthorAvatar}
                  imageSizes="(min-width: 1024px) 30vw, (min-width: 640px) 45vw, 100vw"
                  CustomHeadingTag={CustomHeadingTag}
                  isFullImage={isFullImage}
                  isFirst={isFirst}
                />
              </Skeleton>
            </div>
          )
        );
      })}
      {componentsAfterCards}
    </section>
  );
}
